/**
 * Created by ModelParser
 * Date: 17-09-2022.
 * Time: 18:39.
 */
import {PrescriptionDefinition} from './definitions/PrescriptionDefinition';
import {Client} from "@/core/services/MedicaPro/models/Client";

export class Prescription extends PrescriptionDefinition {

    constructor(json?: any) {
        super(json);
    }

    public static Create(client: Client): Prescription {
        const item = new Prescription();
        item.client_id = client.id;
        return item;
    }

    public get dailyDosageUnit(): string {
        switch (this.daily_dosage_unit) {
            case 'pieces':
                return 'Stk.'
            default:
                return '';
        }
    }

}
